import React from "react";
import ContactForm from "../components/ContactForm";
import useStore from "../context/store";

function Contact() {
  const data = useStore((state) => state);

  // Add basic check for data structure
  const contactFormInfo = data?.store?.contactData?.contactFormInfo;
  const commonData = data?.store?.commonData;

  if (!contactFormInfo || !commonData) {
    // Handle case where data might not be loaded yet
    return <div className="flex justify-center items-center">Loading contact information...</div>;
  }

  return (
    <div>
      {/* No additionalData prop is passed here */}
      <ContactForm contactFormData={contactFormInfo} />

      <div className="max-w-[1400px] mx-auto">
        <div className="h-full flex flex-col md:flex-row justify-between pt-12 md:pt-24 pb-12 md:pb-24 px-4 md:px-0 text-left">
          <div className="space-y-7 w-full">
            <h4 className="uppercase text-xl font-semibold">Contact Details</h4>
            <h1 className="text-6xl font-medium">Thinking of visiting?</h1>
            <a
              href={commonData.locationInfo.locationLink}
              target="_blank"
              rel="noreferrer"
              className="block"
            >
              <button className="py-2 px-3 text-base bg-[#cc673d] text-white md:w-auto w-full cursor-pointer hover:bg-[#b85a36] transition-colors duration-200">
                {" "}
                {/* Added hover */}
                Get Direction
              </button>
            </a>
          </div>
          <div className="flex flex-col md:flex-row justify-around w-full mt-8 md:mt-0">
            <div className="max-w-xs">
              <h4 className="uppercase text-xl font-semibold pb-5">
                Physical Address
              </h4>
              <h3 className="text-lg">
                {commonData.addressInfo.address} {commonData.addressInfo.city}{" "}
                {commonData.addressInfo.state} -{" "}
                {commonData.addressInfo.postalCode}{" "}
                {commonData.addressInfo.country}
              </h3>
            </div>
            <div className="max-w-xs mt-8 md:mt-0">
              <h4 className="uppercase text-xl font-semibold pb-5">Phone</h4>
              <h3 className="text-lg">
                <a
                  href={`tel:${commonData.contactDetails.contact}`}
                  className="text-blue-400 hover:underline"
                >
                  +91 {commonData.contactDetails.contact}
                </a>
              </h3>
              <h4 className="uppercase text-xl font-semibold pb-5 pt-5">
                Email
              </h4>
              <h3 className="text-lg">
                <a
                  href={`mailto:${commonData.contactDetails.email}`}
                  className="text-blue-400 hover:underline"
                >
                  {commonData.contactDetails.email}
                </a>
              </h3>
            </div>
          </div>
        </div>
      </div>
      {/* Fullscreen Google Map */}
      <div className="w-full h-screen">
        <iframe
          src={commonData.locationInfo.mapLocationLink}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;
